import Avatar from "@material-ui/core/Avatar/Avatar";
import List from "@material-ui/core/List/List";
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import ImageIcon from '@material-ui/icons/Image';
import DeleteIcon from '@material-ui/icons/Delete';
import * as moment from "moment";
import * as React from "react";
import { FileModel } from "../model/autogen/FileModel";
import { isArrayNullOrEmpty } from "../utils/array";
import { FilesRequestFactory } from "../model/autogen/FilesController";
//import { withSnackbar, ISnackbarContextProps } from "./with-snackbar";
import { withAuthContext, IAuthContextProps } from "./with-auth-context";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton/IconButton";
import { UserLevel } from "../model/autogen/UserLevel";

export interface IFileAttachmentCallbacks {
    onBeginDeleteFile?: (id: number) => void;
    onFileDeleted?: (id: number) => void;
}

export interface IFileAttachmentListProps extends IFileAttachmentCallbacks {
    files: FileModel[];
    downloadLinkResolver: (id: number) => string;
    editing: boolean;
}

class FileAttachmentListBase extends React.Component<IFileAttachmentListProps & IAuthContextProps, any> {
    constructor(props: IFileAttachmentListProps & IAuthContextProps) {
        super(props);
    }
    download = async (fileModel: FileModel) => {
        const result = await this.props.callApi((fetcher) => FilesRequestFactory.requestDownload(fetcher, fileModel.id));
        const downloadLink = this.props.downloadLinkResolver(result.id);
        if (fileModel.mimeType === "application/pdf") {
            window.open(downloadLink)
        } else {
            window.location.href = downloadLink;
        }
    }
    private onDeleteFile = async (fileModel: FileModel) => {
        if (confirm(`Are you sure you want to delete this file (${fileModel.fileName})?`)) {
            try {
                if (this.props.onBeginDeleteFile)
                    this.props.onBeginDeleteFile(fileModel.id);
                await this.props.callApi((fetcher) => FilesRequestFactory.delete(fetcher, fileModel.id));
                if (this.props.onFileDeleted)
                    this.props.onFileDeleted(fileModel.id);
            } catch (e) {
                alert("Failed to delete file");
            }
        }
    }
    private canDeleteFile = (fileModel: FileModel) => {
        return fileModel.createdById == this.props.user.id || this.props.user.level >= UserLevel.Editor;
    }

    render(): JSX.Element {
        const { files } = this.props;
        if (isArrayNullOrEmpty(files)) {
            return <p>No files attached</p>;
        }
        return <List>
            {files.map(f => <ListItem key={f.id}>
                <Avatar>
                    <ImageIcon />
                </Avatar>
                <div onClick={async () => await this.download(f)}>
                    <ListItemText
                        primary={<a href={'#'}>{f.fileName}</a>} secondary={`Uploaded: ${moment.utc(f.date).format("ddd DD MMM YYYY")}`}
                    />
                </div>
                {this.canDeleteFile(f) && this.props.editing && <ListItemSecondaryAction>
                    <IconButton aria-label="Delete" title="Delete this file" onClick={e => this.onDeleteFile(f)}>
                        <DeleteIcon />
                    </IconButton>
                </ListItemSecondaryAction>}
            </ListItem>)}
        </List>;
    }
}

export const FileAttachmentList = withAuthContext(FileAttachmentListBase) as any;


// WEBPACK FOOTER //
// ./src/components/file-attachment-list.tsx